module.exports = __webpack_public_path__ + "media/LandingPageAssets/audio-4b23c291.png";